// src/components/LoginPage.jsx
import React, { useEffect, useState } from 'react';
import { signInWithGoogle } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo3.png';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsandConditions'; 

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <>
      <div className="min-h-screen bg-[#181A1B] flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-[#2C2F30] rounded-2xl shadow-2xl border border-[#3A3D3E] p-8 text-center">
          <div className="mb-8">
          <img 
              src={logo} 
              alt="Lucid Logo"
              className="h-24 w-24 mx-auto mb-6"
            />
          <h1 className="text-4xl font-bold text-[#EAECEF] mb-3">
            Lucid v1.8
          </h1>
          <p className="text-blue-200 text-lg">
            Advanced Text-to-Speech Technology
          </p>
        </div>
          
          <div className="space-y-6">
            <p className="text-[#B0B4BB] text-sm">
              Sign in to access premium voice profiles and advanced features
            </p>
            
            <button onClick={handleGoogleSignIn}
              className="w-full bg-[#178A94] hover:bg-[#146E75] text-[#EAECEF] font-medium rounded-lg 
                     py-3 px-4 flex items-center justify-center gap-3 transition-all"
            >
              <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5"/>
              Sign in with Google
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-[#3A3D3E]">
            <p className="text-[#7C8085] text-sm">
              By signing in, you agree to our{' '}
              <button 
                onClick={() => setShowTerms(true)}
                className="text-[#178A94] hover:text-[#146E75] transition-colors"
              >
                Terms of Service
              </button>
              {' '}and{' '}
              <button
                onClick={() => setShowPrivacy(true)}
                className="text-[#178A94] hover:text-[#146E75] transition-colors"
              >
                Privacy Policy
              </button>
            </p>
          </div>
        </div>
      </div>

      {/* Modals */}
      {showPrivacy && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-[#2C2F30] rounded-lg max-w-2xl max-h-[90vh] overflow-y-auto p-6
                        scrollbar-thin scrollbar-thumb-[#178A94] scrollbar-track-[#2C2F30]
                        hover:scrollbar-thumb-[#146E75]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-[#EAECEF]">Privacy Policy</h2>
              <button 
                onClick={() => setShowPrivacy(false)}
                className="text-[#B0B4BB] hover:text-[#EAECEF]"
              >
                ✕
              </button>
            </div>
            <PrivacyPolicy />
          </div>
        </div>
      )}

      {showTerms && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-[#2C2F30] rounded-lg max-w-2xl max-h-[90vh] overflow-y-auto p-6
                        scrollbar-thin scrollbar-thumb-[#178A94] scrollbar-track-[#2C2F30]
                        hover:scrollbar-thumb-[#146E75]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-[#EAECEF]">Terms of Service</h2>
              <button 
                onClick={() => setShowTerms(false)}
                className="text-[#B0B4BB] hover:text-[#EAECEF]"
              >
                ✕
              </button>
            </div>
            <TermsAndConditions />
          </div>
        </div>
      )}
    </>
  );
};

export default LoginPage;